import { render, staticRenderFns } from "./ParticipantsTab.vue?vue&type=template&id=793a815e&scoped=true"
import script from "./ParticipantsTab.vue?vue&type=script&lang=js"
export * from "./ParticipantsTab.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsTab.vue?vue&type=style&index=0&id=793a815e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a815e",
  null
  
)

export default component.exports